var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var pikaDay = require('pikaday');

module.exports = function() {
    $('.js-datepicker').each(function() {
        new pikaDay({
            field:  this,
            format: $(this).data('dateformat') || 'MMM D, YYYY',
            minDate: $(this).attr('min') ? new Date($(this).attr('min') + ' 00:00:00') : null,
            maxDate: $(this).attr('max') ? new Date($(this).attr('max') + ' 00:00:00') : null
        });
    });
};
